import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import notificationSummariesService from 'services/notification-summaries';

const initialState = {
  loading: false,
  summaries: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
    sort: 'created_at',
    column: 'created_at',
    order: 'desc',
  },
  meta: {},
};

export const fetchNotificationSummaries = createAsyncThunk(
  'notificationSummaries/fetchNotificationSummaries',
  (params = {}) => {
    return notificationSummariesService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  },
);

export const fetchNotificationSummariesById = createAsyncThunk(
  'notificationSummaries/fetchNotificationSummariesById',
  (id) => {
    return notificationSummariesService.getById(id).then((res) => res);
  },
);

const notificationSummariesSlice = createSlice({
  name: 'notificationSummaries',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchNotificationSummaries.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchNotificationSummaries.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.summaries = payload.data || [];
      state.meta = {
        total: payload.total || 0,
        current_page: payload.current_page || 1,
        per_page: payload.per_page || 10,
      };
      state.params.page = payload.current_page || 1;
      state.params.perPage = payload.per_page || 10;
      state.error = '';
    });
    builder.addCase(fetchNotificationSummaries.rejected, (state, action) => {
      state.loading = false;
      state.summaries = [];
      state.error = action.error.message;
    });

    // Handle fetchNotificationSummariesById
    builder.addCase(fetchNotificationSummariesById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchNotificationSummariesById.fulfilled,
      (state, action) => {
        const { payload } = action;
        state.loading = false;
        state.summaries = payload.data || [];
        state.meta = payload.meta || {};
        state.error = '';
      },
    );
    builder.addCase(
      fetchNotificationSummariesById.rejected,
      (state, action) => {
        state.loading = false;
        state.summaries = [];
        state.error = action.error.message;
      },
    );
  },
});

export default notificationSummariesSlice.reducer;
